import {
	AutomationIcon,
	PageTreeExporterIcon,
	ThemesIcon,
	ManagePagesIconV2,
	IntegrationsIconV2,
	LookAndFeelIconV2,
	ManageSpaceIconV2,
	SpacePermissionsIconV2,
	DataProtectionIconV2,
} from '../landing-page/img/index.ts';
import {
	AUTOMATION_WEBITEM_SECTION_ID_V1,
	AUTOMATION_WEBITEM_SECTION_ID_V2,
} from '../web-item-sections/useSpaceSettingsWebItemSectionsFromQuery.tsx';

const WEB_ITEM_ID_MAP_TO_ICON = {
	'-system.space.tools-com.metainf.confluence.plugin.pagetreeexporter.pagetree-word-exporter-plugin__cex-admin-space-tools':
		PageTreeExporterIcon,
	'-system.space.tools-com.refinedwiki.confluence.cloud.refinedtheme__rw-theming-section':
		ThemesIcon,
	'-system.space.tools-contenttools': ManagePagesIconV2,
	'-system.space.tools-integrations': IntegrationsIconV2,
	'-system.space.tools-lookandfeel': LookAndFeelIconV2,
	'-system.space.tools-overview': ManageSpaceIconV2,
	'-system.space.tools-permissions': SpacePermissionsIconV2,
	'-system.space.tools-data-protection': DataProtectionIconV2,
	[AUTOMATION_WEBITEM_SECTION_ID_V1]: AutomationIcon,
	[AUTOMATION_WEBITEM_SECTION_ID_V2]: AutomationIcon,
};

export const getWebItemIdMapToIcon = () => WEB_ITEM_ID_MAP_TO_ICON;
